@if (control) {
  <mat-form-field class="{{ additionalClass() }}" [floatLabel]="floatLabel() ? 'always' : 'auto'">
    <mat-label [ngClass]="{
      'text-red': control.invalid && (control.dirty || control.touched)
    }">{{ label() }}</mat-label>
    <input
      matInput
      type="text"
      [autocomplete]="autocomplete()"
      [formControl]="control"
      [mask]="maskComputed()"
      [thousandSeparator]="','"
      [prefix]="prefixComputed()"
      [dropSpecialCharacters]="true"
      [pattern]="patternComputed()"
      [attr.disabled]="disabled"
      [step]="stepComputed()"
      [min]="minComputed()"
      [max]="max()"
      [readonly]="readonly()"
      [placeholder]="placeholderComputed()"
      [ngClass]="{
        'text-center': alignment() === 'center',
        'text-left': alignment() === 'left',
        'text-right': alignment() === 'right'
      }"
      />
      @if (startHint()) {
        <mat-hint align="start">
          <strong>{{ startHint() }}</strong>
        </mat-hint>
      }
      @if (endHint()) {
        <mat-hint align="end">
          <strong>{{ endHint() }}</strong>
        </mat-hint>
      }
      <!-- A 'message' error is more specific, so show it alone rather than stacked under "Required" -->
      @if (showError && control.hasError('required') && !control.hasError('message')) {
        <mat-error [id]="''">Required</mat-error>
      }
      @if (control.hasError('pattern')) {
        <mat-error>{{ patternErrorMessageComputed() }}</mat-error>
      }
      @if (control.hasError('min')) {
        <mat-error [id]="''">{{ minError() }}</mat-error>
      }
      @if (control.hasError('max')) {
        <mat-error [id]="''">{{ maxError() }}</mat-error>
      }
      @if (control.hasError('message')) {
        <mat-error [id]="''">{{ control.getError('message') }}</mat-error>
      }
    </mat-form-field>
  }
